module.exports = __webpack_public_path__ + "static/3-75153903a161d742fa81f4f527378fcd.png";